module.exports = __webpack_public_path__ + "static/media/earn.977e07d2.svg";